import {FormProvider, useForm} from "react-hook-form";
import {useCreateProductContext} from "../../context/create-product";
import {
  CreateProductBasicFormStepFormValues,
  createProductBasicFormStepFormValidationSchema,
} from "./schema-validation";
import {yupResolver} from "@hookform/resolvers/yup";
import {Alert, Button, Col, Row, Space} from "antd";
import {StyledServiceButtonWrapper} from "../../../../../styles/onboarding/onboarding";
import {useNavigate} from "react-router-dom";
import {CreateProductOfferingForm} from "../../../../../components/offering-form/products";
import {CreateProductFormValues} from "../../reducers/create-product/types";
import {useCreateEditProductHook, useCreateProductHook} from "../../hooks/create-product";

export function CreateProductBasicFormStep() {
  const navigate = useNavigate();
  const {
    dispatch,
    state: {formData, apiResponseData},
  } = useCreateProductContext();

  const formMethods = useForm<CreateProductBasicFormStepFormValues>({
    resolver: yupResolver(createProductBasicFormStepFormValidationSchema),
    mode: "onSubmit",
    defaultValues: formData,
  });

  const {createProduct, isCreatingProduct} = useCreateProductHook();
  const {createEditProduct, isCreateServiceEditing} = useCreateEditProductHook();

  function onSubmit(values: CreateProductBasicFormStepFormValues) {
    if (apiResponseData) {
      const payload: CreateProductFormValues = {
        ...formData,
        ...values,
      };
      createEditProduct(payload, () => {
        dispatch({
          type: "update-create-product-form-step",
          payload: "coverImagesUpload",
        });
      });
    } else {
      const payload: CreateProductFormValues = {
        bookingQuestions: [],
        currencies: values.currencies,
        description: values.description,
        hideFromProfile: values.hideFromProfile,
        isUrlRedirect: values.isUrlRedirect,
        redirectAfterPurchase: values.redirectAfterPurchase,
        telegramGroupId: values.telegramGroupId,
        name: values.name,
        priceType: values.priceType,
        requestCustomerPhoneNumber: values.requestCustomerPhoneNumber,
        limitUnitsPerTransaction: values.limitUnitsPerTransaction,
        purchaseLimit: values.purchaseLimit,
        url_redirect: values.url_redirect,
        enable_currency_conversion: true,
        selected_currencies: values.selected_currencies || [],
        coverImage: "",
      };
      createProduct(payload);
    }
  }

  const isFormError = Object.keys(formMethods.formState.errors).length > 0;
  const isGeneralInformationError =
    formMethods.formState.errors.name ||
    formMethods.formState.errors.description ||
    formMethods.formState.errors.coverImage;
  const isPricingError =
    formMethods.formState.errors.priceType || formMethods.formState.errors.currencies;
  const isSettingsError =
    formMethods.formState.errors.hideFromProfile ||
    formMethods.formState.errors.isUrlRedirect ||
    formMethods.formState.errors.redirectAfterPurchase ||
    formMethods.formState.errors.telegramGroupId ||
    formMethods.formState.errors.requestCustomerPhoneNumber ||
    formMethods.formState.errors.limitUnitsPerTransaction ||
    formMethods.formState.errors.purchaseLimit ||
    formMethods.formState.errors.url_redirect;

  // console.log({watch: formMethods.watch(), errors: formMethods.formState.errors});
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={formMethods.handleSubmit(onSubmit)} autoComplete="off">
        <Space direction="vertical" size={16} style={{display: "flex"}}>
          <CreateProductOfferingForm
            isGeneralInformationError={!!isGeneralInformationError}
            isPricingError={!!isPricingError}
            isSettingsError={!!isSettingsError}
          />
          {isFormError && (
            <Alert
              message="Please fill in the required fields above, outlined in red"
              type="warning"
            />
          )}

          <Row gutter={[0, 16]}>
            <Col span={24} sm={12}>
              <StyledServiceButtonWrapper>
                <Button
                  className="secondary-btn"
                  onClick={() => {
                    dispatch({
                      type: "reset-state",
                    });
                    navigate("/products");
                  }}
                  block
                  size="small"
                  type="default"
                >
                  Back
                </Button>
                <Button
                  block
                  type="primary"
                  htmlType={"submit"}
                  size="small"
                  loading={isCreatingProduct || isCreateServiceEditing}
                  disabled={isFormError || Object.values(formMethods.watch()).length < 1}
                >
                  Next
                </Button>
              </StyledServiceButtonWrapper>
            </Col>
          </Row>
        </Space>
      </form>
    </FormProvider>
  );
}
